const state = {
  exceptions: [],
  mobile: false,
  showPageLoader: true,
};

export default state;
